import { render, staticRenderFns } from "./wrdbList.vue?vue&type=template&id=0de84bff&scoped=true"
import script from "./wrdbList.vue?vue&type=script&lang=js"
export * from "./wrdbList.vue?vue&type=script&lang=js"
import style0 from "./wrdbList.vue?vue&type=style&index=0&id=0de84bff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de84bff",
  null
  
)

export default component.exports